import React from 'react';
import cx from 'classnames';

import Card from '@marketing/components/card';

import OfficialQuestionsIcon from './assets/official_questions_icon.svg';
import PracticeQuestionsIcon from './assets/practice_questions_icon.svg';
import PracticeTestsIcon from './assets/practice_tests_icon.svg';
import ScorePredictorIcon from './assets/score_predictor_icon.svg';
import StudySchedulesIcon from './assets/study_schedules_icon.svg';
import VideoLessonsIcon from './assets/video_lessons_icon.svg';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-l">
      <div className="d-flex flex-column gap-m">
        <h1 className={cx('u-margin-A-n text-bold text-center text-gray-darker', styles.heroHeader)}>
          Improve Your GRE<span className={styles.registeredMark}>®</span> Score, Guaranteed!
        </h1>

        <div className="text-center text-inter" style={{ fontSize: 18 }}>
          Prep smart at an affordable price. Fully optimized for the shorter GRE.
        </div>
      </div>

      <div className="d-flex flex-column gap-s gap-lg-m">
        <div
          className={cx(
            styles.valuePropCardsContainer,
            'align-items-center d-flex flex-1 flex-column flex-lg-row gap-s gap-lg-m'
          )}
        >
          <Card className={cx(styles.valuePropCard, 'd-flex flex-column gap-m')} skewAngle={-1}>
            <div className="align-items-center d-flex gap-xs">
              <div>
                <img
                  alt="Practice tests icon"
                  height="24px"
                  src={PracticeTestsIcon}
                  width="24px"
                />
              </div>

              <div className="text-uppercase">
                <strong>Practice Tests</strong>
              </div>
            </div>

            <div style={{ fontSize: 15 }}>
              Timed, full-length practice tests from our pool of questions
            </div>
          </Card>

          <Card className={cx(styles.valuePropCard, 'd-flex flex-column gap-m')} skewAngle={1}>
            <div className="align-items-center d-flex gap-xs">
              <div>
                <img
                  alt="Practice tests icon"
                  height="24px"
                  src={PracticeTestsIcon}
                  width="24px"
                />
              </div>

              <div className="text-uppercase">
                <strong>Official Content</strong>
              </div>
            </div>

            <div style={{ fontSize: 15 }}>
              8 full sections worth of licensed official GRE® questions from ETS
            </div>
          </Card>

          <Card className={cx(styles.valuePropCard, 'd-flex flex-column gap-m')} skewAngle={-1}>
            <div className="align-items-center d-flex gap-xs">
              <div>
                <img
                  alt="Practice questions icon"
                  height="24px"
                  src={PracticeQuestionsIcon}
                  width="24px"
                />
              </div>

              <div className="text-uppercase">
                <strong>1600+ Practice Questions</strong>
              </div>
            </div>

            <div style={{ fontSize: 15 }}>
              Learn from your mistakes with a video explanation to every question
            </div>
          </Card>
        </div>

        <div
          className={cx(
            styles.valuePropCardsContainer,
            'align-items-center d-flex flex-1 flex-column flex-lg-row gap-s gap-lg-m  justify-content-lg-end'
          )}
        >
          <Card className={cx(styles.valuePropCard, 'd-flex flex-column gap-m')} skewAngle={-1}>
            <div className="align-items-center d-flex gap-xs">
              <div>
                <img
                  alt="Video lessons icon"
                  height="24px"
                  src={VideoLessonsIcon}
                  width="24px"
                />
              </div>

              <div className="text-uppercase">
                <strong>Expert Video Lessons</strong>
              </div>
            </div>

            <div style={{ fontSize: 15 }}>
              Prepare for every section, on any device and 100% online
            </div>
          </Card>

          <Card className={cx(styles.valuePropCard, 'd-flex flex-column gap-m')} skewAngle={1}>
            <div className="align-items-center d-flex gap-xs">
              <div>
                <img
                  alt="Study schedules icon"
                  height="24px"
                  src={StudySchedulesIcon}
                  width="24px"
                />
              </div>

              <div className="text-uppercase">
                <strong>Custom Study Schedules</strong>
              </div>
            </div>

            <div style={{ fontSize: 15 }}>
              Study checklists to stay motivated, 1 week to 6 months long
            </div>
          </Card>

          <Card className={cx(styles.valuePropCard, 'd-flex flex-column gap-m')} skewAngle={-1}>
            <div className="align-items-center d-flex gap-xs">
              <div>
                <img
                  alt="Score predictor icon"
                  height="24px"
                  src={ScorePredictorIcon}
                  width="24px"
                />
              </div>

              <div className="text-uppercase">
                <strong>Accurate Score Predictor</strong>
              </div>
            </div>

            <div style={{ fontSize: 15 }}>
              Be confident when you’re ready with our score predictor tool
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};
